import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  AgentGroupResponse,
  AllAgentGroupsResponse,
  AllAgentsData,
  AllAgentsResponse,
  SaveLeadFromMobileAppData,
  SaveLeadFromMobileAppResponse,
  TopAgentsByAverageRatingData,
  TopAgentsByAverageRatingResponse,
  TopTeamFlags,
} from '@app/home/services/models/our-specialists-model';
import { environment } from '@environments/environment';
import { catchError, exhaustMap } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { EMPTY, Observable } from 'rxjs';
import { DeviceService } from '@helpers/device.service';
import { Store } from '@ngrx/store';
import { AppState } from '@app/ngrx/app-state/app-state';
import { getAgentsCollection, getAgentsLoading, getAgentsTotal } from '@app/ngrx/agents/states/agents-getters.state';
import { getAllAgents, getMoreAgents } from '@app/ngrx/agents/actions';
import { getTopTeam } from '@app/ngrx/top-team/actions';
import {
  getTopTeamCollection,
  getTopTeamLoading,
  getTopTeamTotal
} from '@app/ngrx/top-team/states/top-team.getters.state';

@Injectable({
  providedIn: 'root',
})
export class AgentsService {

  agentsCollection$: Observable<any> = this.store.select(getAgentsCollection);
  agentsLoading$: Observable<boolean> = this.store.select(getAgentsLoading);
  agentsTotalCount$: Observable<number> = this.store.select(getAgentsTotal);

  topTeamCollection$: Observable<any> = this.store.select(getTopTeamCollection);
  topTeamLoading$: Observable<boolean> = this.store.select(getTopTeamLoading);
  topTeamTotalCount$: Observable<number> = this.store.select(getTopTeamTotal);

  constructor(
    private http: HttpClient,
    private messageService: MessageService,
    private deviceService: DeviceService,
    private store: Store<AppState>,
  ) {}

  public getAllAgents(filter: TopAgentsByAverageRatingData) {
    return this.http.post<TopAgentsByAverageRatingResponse>(`${environment.apiUserManagerUrl}/open-api/agents/topAgentsByAverageRating`, filter).pipe(
      catchError((er) => {
        this.messageService.add({ severity: 'error', summary: er.message });
        return EMPTY;
      }),
    );
  }

  public sendRequestToSpecialist(params: SaveLeadFromMobileAppData) {
    return this.deviceService
      .getDeviceUUID()
      .pipe(exhaustMap((deviceUuid) => this.http.post<SaveLeadFromMobileAppResponse>(`${environment.apiDataManagerUrl}/open-api/leads/saveLeadFromMobileApp`, { ...params, deviceUuid })));
  }

  getAllAgentsStore(filter: AllAgentsData) {
    this.store.dispatch(getAllAgents({ filter }));
  }

  getMoreAgents(filter: AllAgentsData) {
    this.store.dispatch(getMoreAgents({ filter }));
  }

  public getAllAgentsByFilter(filter: AllAgentsData): Observable<AllAgentsResponse> {
    return this.http.post(`${environment.apiUserManagerUrl}/open-api/agents/findAgentsByFilter`, filter);
  }

  public getTopTeamRequest(filter: { pageNumber: number; pageSize: number; sortBy?: string; direction?: string; agentGroupFlagTypes?: TopTeamFlags[] }) {
    this.store.dispatch(getTopTeam({ filter }));
  }

  public getAgentGroups(filter: { pageNumber: number; pageSize: number; sortBy?: string; direction?: string; agentGroupFlagTypes?: TopTeamFlags[] }): Observable<AllAgentGroupsResponse> {
    return this.http.post(`${environment.apiViewManagerUrl}/open-api/agent-groups/getAllAgentGroups`, filter);
  }

  getAgentGroup(id: number): Observable<AgentGroupResponse> {
    return this.http.get(`${environment.apiViewManagerUrl}/open-api/agent-groups/getAgentGroupView/${id}`);
  }

  public getAgentGroupsFlags() {
    return this.http.get(`${environment.apiViewManagerUrl}/open-api/agent-groups/flags`);
  }
}
